import { getCookie, setCookie } from '../utils';

$(() => {
  const $cookiePopup = $('.js-cookie-consent');
  const $cookieAllowButton = $('.js-cookies-allow');

  if (!$cookiePopup.length || !$cookieAllowButton.length) {
    return;
  }

  if (getCookie('CookiePolicyAccepted') !== 'true') {
    $cookiePopup.addClass('cookie-consent-container--visible');
  }

  $cookieAllowButton.click((e) => {
    e.preventDefault();
    $cookiePopup.slideUp();
    setCookie('CookiePolicyAccepted', 'true', 365);
  });
});
